import {applyMiddleware, compose, createStore} from 'redux';
import {monitorReducerEnhancer} from './monitorReducer';
import {createLogger} from 'redux-logger';
import {rootReducer} from './reducers/reducers';
import thunk from 'redux-thunk';
import reduxPromise from 'redux-promise';
import promise from 'redux-promise-middleware'
import {CONFIG} from "config/config";


export const StoreInit = (preloadedState) => {
    const config = CONFIG.ENVIRONMENT;
    const middlewares = [
        thunk,
        promise,
        reduxPromise,
    ];

    if (config.REDUX_LOGGER) {
        middlewares.push(createLogger());
    }

    const composeEnhancers = (config.REDUX_DEVTOOLS && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
    const middlewareEnhancer = applyMiddleware(...middlewares);
    const enhancers = [middlewareEnhancer];

    if (config.REDUX_MONITOR) {
        enhancers.push(monitorReducerEnhancer);
    }

    return createStore(rootReducer, preloadedState, composeEnhancers(...enhancers));
};
